import React, { Component } from "react";
import PropTypes from "prop-types";
import LineSeries from "./LineSeries";

/**
 * SO (Oscilador Estocástico, FML.SO) — painel próprio, 2 linhas: SK e SD.
 * yAccessor(d) retorna { sk, sd }.
 */
class SOSeries extends Component {
  constructor(props) {
    super(props);
    this.skAccessor = this.skAccessor.bind(this);
    this.sdAccessor = this.sdAccessor.bind(this);
  }
  skAccessor(d) {
    const v = this.props.yAccessor(d);
    return v && v.sk;
  }
  sdAccessor(d) {
    const v = this.props.yAccessor(d);
    return v && v.sd;
  }
  render() {
    const { strokeSk, strokeSd, className } = this.props;
    return (
      <g className={className}>
        <LineSeries yAccessor={this.skAccessor} stroke={strokeSk} fill="none" />
        <LineSeries yAccessor={this.sdAccessor} stroke={strokeSd} fill="none" />
      </g>
    );
  }
}

SOSeries.propTypes = {
  yAccessor: PropTypes.func.isRequired,
  strokeSk: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  strokeSd: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  className: PropTypes.string,
};

SOSeries.defaultProps = {
  strokeSk: { color: "#FFFF00" },
  strokeSd: { color: "#FF0000" },
  className: "react-stockcharts-so-series",
};

export default SOSeries;
